export enum VehicleAdapter {
  Type1ToType2 = 'CABLE_TYPE1_TO_TYPE2',
  TeslaCSS2 = 'ADAPTER_TESLA_CSS2',
  TeslaChademo = 'ADAPTER_TESLA_CHADEMO',
  Schuko = 'ADAPTER_SCHUKO',
  SchukoToType2 = 'ADAPTER_SCHUKO_TO_TYPE2',
  NoAdapter = 'NO_ADAPTER'
}

export enum VehiclePlug {
  Type1 = 'Type 1 (SAE J1772)',
  Chademo = 'CHAdeMO',
  CCS2 = 'CCS2',
  Type2 = 'TYPE2',
  Schuko = 'Schuko',
  Type2Tesla = 'TYPE2 - Tesla',
  CCS2Tesla = 'CCS2 Tesla',
  CCS2TeslaV2 = 'CCS Tesla V2',
  CCS2TeslaV3 = 'CCS Tesla V3',
  Type2TeslaSupercharger = 'TYPE2 - Tesla Supercharger'
}
